import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import store from './store'
import CoreuiVue from '@coreui/vue'
import VueMask from 'v-mask'
import VueSimpleAlert from 'vue-simple-alert'

Vue.use(VueRouter)
Vue.use(CoreuiVue)
Vue.use(VueMask)
Vue.use(VueSimpleAlert)

Vue.config.productionTip = false

import routes from './router/index'
import validateRoute from './router/validateRoute'
import { getRoutesModel } from './general'
import { iconsSet as icons } from './assets/icons/icons.js'

// import { checkVersion } from "./utils/version-checker";

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: routes(store)
})

router.beforeEach(async (to, from, next) => {
  if ((to.path === '') || (to.path === '/') || (to.path === '/login') || (to.path === '/404')) {
    next()
  } else {
    const routesModel = store.state.user.data.routesAccessModel ? store.state.user.data.routesAccessModel : await getRoutesModel();
    // const routesModel = await getRoutesModel();

    console.log("Routes Models...");
    console.log(routesModel);

    if (routesModel) {    
      const validRoute = validateRoute(to, routesModel);
      
      validRoute ? next() : next('/404')
    } else {
      next('/login')
    }
  }
});

fetch("/version.json", { cache: "no-store" })
  .then(res => res.json())
  .then(data => {
    // Comprobar si la versión y hash ya están establecidos    
    if (!store.state.app.hash) {
      store.commit('setAppVersion', { version: data.version, hash: data.hash });
    }
    
    // Comprobar si hay una nueva versión
    if (data.hash !== store.state.app.hash) {
      console.log("⚠️ Nueva versión detectada:", data.hash);
      console.log("Reloading app for new version...");

      store.commit('setAppVersion', { version: data.version, hash: data.hash });

      window.location.reload(true); // fuerza recarga total
    }
  });

new Vue(
  {
    router,
    icons,
    store,
    render: h => h(App),
  }
).$mount('#app')
